import AccordionApp from "./AccordionApp";

export default function FAQs() {
  return (
    <>
      <center>
        <div id="faqs" className="container-fluid">
          <h2 className="head_pt main_banner-heading mob-faq">FAQ</h2>

          <AccordionApp />
        </div>
      </center>
    </>
  );
}
